
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcGaugeVertical as ObcGaugeVerticalElement} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/gauge-vertical/gauge-vertical.js';
 
 
 

 
 export const ObcGaugeVertical = createComponent({
   react: React,
   tagName: 'obc-gauge-vertical',
   elementClass: ObcGaugeVerticalElement,
   events: {
     
     onScaleDimensionsChanged: 'scale-dimensions-changed' as EventName<CustomEvent>,
   }
  });
 
 